const updateEquipments = {
  name: 'EQUIPMENT',
  conditionTrue: 'REACTIVATED',
  conditionFalse: 'INACTIVATED',
  newMaintenanceStatus: 'MAINTENANCE',
  newMaintenanceStatusTrue: 'SENT TO',
  newMaintenanceStatusFalse: 'RETURN OF'
};

export default updateEquipments;
